import React from 'react';
import { CONTEXTS } from '@/data/categories';

export const ContextToggle = ({ value, onChange }) => {
  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-body mb-3">
        Choose a context
      </label>
      <div className="flex flex-wrap gap-2">
        {CONTEXTS.map((context) => (
          <button
            key={context.id}
            onClick={() => onChange(context.id)}
            className={`
              px-4 py-2 rounded-lg text-sm font-medium
              transition-all duration-200
              border
              ${value === context.id
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-card text-body border-border hover:border-primary/50 hover:bg-secondary'
              }
            `}
          >
            {context.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContextToggle;
